import React from 'react';
import styles from './MapSkeleton.module.scss';

const MapSkeleton = ({ dark = false, label = 'Loading map…' }) => {
  return (
    <div
      className={`${styles.skeleton} ${dark ? styles.dark : ''}`}
      role="status"
      aria-label={label}
    >
      <div className={styles.shimmer} />
      <div className={styles.gridLines} />

      {/* SVG Map contour curves */}
      <svg
        className={styles.topography}
        viewBox="0 0 800 500"
        preserveAspectRatio="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
      >
        <path
          d="M -50,150 Q 200,80 450,220 T 850,160"
          strokeWidth="1.5"
          vectorEffect="non-scaling-stroke"
        />
        <path
          d="M -50,280 Q 250,380 520,240 T 850,320"
          strokeWidth="1.5"
          vectorEffect="non-scaling-stroke"
        />
        <path
          d="M 120,-30 Q 340,160 380,480"
          strokeWidth="1.2"
          vectorEffect="non-scaling-stroke"
        />
        <path
          d="M 620,-30 Q 580,260 700,530"
          strokeWidth="1.2"
          vectorEffect="non-scaling-stroke"
        />
        <circle cx="400" cy="230" r="140" strokeWidth="1" strokeDasharray="6,6" vectorEffect="non-scaling-stroke" />
      </svg>

      {/* Center Radar & Pin Marker */}
      <div className={styles.pinTarget}>
        <div className={styles.pulseWrapper}>
          <div className={styles.pulseRing} />
          <div className={`${styles.pulseRing} ${styles.pulseRingDelay}`} />
          <svg
            className={styles.markerIcon}
            width="32"
            height="44"
            viewBox="0 0 25 41"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden="true"
          >
            <path
              d="M12.5 0C5.596 0 0 5.596 0 12.5C0 21.875 12.5 41 12.5 41C12.5 41 25 21.875 25 12.5C25 5.596 19.404 0 12.5 0Z"
              fill="currentColor"
              stroke="#FFFFFF"
              strokeWidth="0.8"
            />
            <circle cx="12.5" cy="12.5" r="4.5" fill="#FFFFFF" />
          </svg>
        </div>

        <div className={styles.loadingBadge}>
          <span className={styles.badgeDot} />
          <span>{label}</span>
        </div>
      </div>

      {/* Mock Map Zoom Controls */}
      <div className={styles.mockControls} aria-hidden="true">
        <div className={styles.mockBtn}>+</div>
        <div className={styles.mockBtn}>−</div>
      </div>
    </div>
  );
};

export default MapSkeleton;
